import { PartialProduct } from "@shared/types";
import { Steps } from "components/ProductDetails/Cylinder/ProductDetailsCylinder";
import { ITEM_BRAND } from "config";
import { LocalizationContext } from "context/localization";
import { logProductDetailViewEvent } from "helpers/analyticsLogger";
import { useCallback, useContext, useEffect, useMemo } from "react";
import { GetItemsByGtinQuery } from "services/graphql/generated";

export const useProductsCylinderAnalytics = (
  currency: string,
  allCylindersData: GetItemsByGtinQuery | undefined,
  analyticsCategoryName: string | null | undefined,
) => {
  const { formatPriceByLocale } = useContext(LocalizationContext);

  const itemsForLogging: PartialProduct[] = useMemo(() => {
    if (
      allCylindersData &&
      allCylindersData.items?.items &&
      analyticsCategoryName &&
      currency
    ) {
      return allCylindersData.items.items.map((item) => {
        return {
          itemId: item.id,
          gtin: item.gtin,
          itemName: item.title,
          itemBrand: ITEM_BRAND,
          itemCategory: analyticsCategoryName,
          price: item.price ? item.price / 100 : 0,
          itemListName: undefined,
          currency,
          quantity: 1,
        };
      });
    }
    return [];
  }, [allCylindersData, analyticsCategoryName, currency]);

  useEffect(() => {
    if (itemsForLogging.length > 0 && currency) {
      const price = itemsForLogging.reduce(
        (prev, current) => (prev += current.price as number),
        0,
      );
      logProductDetailViewEvent(currency, itemsForLogging, price);
    }
  }, [itemsForLogging, currency]);

  const getContinueButtonAnalytics = useCallback(
    (currentStep: Steps, currentPrice: number) => {
      switch (currentStep) {
        case 0:
          return {
            "bi-type": "Co2 Cylinder - Select a cylinder",
            "bi-id": "Continue",
          };
        case 1:
          return {
            "bi-type": "Co2 Cylinder - Add to cart",
            "bi-id": `Add to cart for ${formatPriceByLocale(currentPrice)}`,
          };
        default:
          return {};
      }
    },
    [formatPriceByLocale],
  );

  return { itemsForLogging, getContinueButtonAnalytics };
};
